import { render } from "./organizationHotelsAdd.vue?vue&type=template&id=98f4414a"
import script from "./organizationHotelsAdd.vue?vue&type=script&lang=js"
export * from "./organizationHotelsAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__